module.exports = __webpack_public_path__ + "img/crown2.3435136.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/community/crown2.png
// module id = CjD1
// module chunks = 15